// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__LnTJs","tag":"style_tag__DQyRM","isVisible":"style_isVisible__9UB7q","expandButton":"style_expandButton__0jvWE","link":"style_link__n1_cf"};